<div #chartStackedBar style="width: 100%; height: 100%; position: relative;"></div>
